<div class="modal-header">
    <h4 class="modal-title">Importer des pré-inscriptions</h4>
    <button *ngIf="!importing" type="button" class="close" aria-label="Close" (click)="dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="import-steps mb-3">
        <span class="badge badge-pill" [ngClass]="step === 1 ? 'badge-primary' : 'badge-light'">1 Fichier</span>
        <i class="fas fa-chevron-right text-secondary mx-2"></i>
        <span class="badge badge-pill" [ngClass]="step === 2 ? 'badge-primary' : 'badge-light'">2 Aperçu</span>
        <i class="fas fa-chevron-right text-secondary mx-2"></i>
        <span class="badge badge-pill" [ngClass]="step === 3 ? 'badge-primary' : 'badge-light'">3 Import</span>
    </div>

    <!-- Étape 1 : fichier -->
    <ng-container *ngIf="step === 1">
        <div class="form-group d-flex align-items-center">
            <!-- Sans fichier, le texte natif « Aucun fichier sélectionné » est masqué au profit des formats acceptés -->
            <input class="form-control-file file-input" [class.no-file]="!file" type="file" id="importFile"
                [accept]="acceptedExtensions" (change)="onFileChange($event)">
            <span *ngIf="!file" class="ml-2 text-muted">{{acceptedFormatsLabel}}</span>
        </div>
        <div *ngIf="fileError" class="alert alert-danger">
            {{fileError}}
        </div>
        <div class="text-secondary">
            <p class="mb-2">
                Chaque ligne du fichier correspond à une pré-inscription à créer. Les colonnes attendues dans le
                fichier sont les suivantes :
            </p>
            <table class="table table-sm mb-0 expected-columns">
                <thead>
                    <tr>
                        <th scope="col">Champ</th>
                        <th scope="col">Type</th>
                        <th scope="col">Obligatoire</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let column of expectedColumns">
                        <td>{{column.label}}</td>
                        <td>{{column.type}}</td>
                        <td>{{column.required ? 'Oui' : 'Non'}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </ng-container>

    <!-- Étape 2 : analyse et aperçu -->
    <ng-container *ngIf="step === 2">
        <div *ngIf="analyzing">
            <p class="mb-2">Analyse du fichier {{file?.name}}…</p>
            <ngb-progressbar type="primary" [value]="analysisProgress" [showValue]="true"></ngb-progressbar>
        </div>

        <div *ngIf="!analyzing && analysisError" class="alert alert-danger">
            {{analysisError}}
        </div>

        <ng-container *ngIf="!analyzing && !analysisError">
            <div class="import-table-wrapper">
                <table class="table table-sm table-striped mb-0">
                    <thead>
                        <tr>
                            <th scope="col">Ligne</th>
                            <th scope="col">Prénom</th>
                            <th scope="col">Nom</th>
                            <th scope="col">Email</th>
                            <th scope="col">Téléphone</th>
                            <th scope="col">Session</th>
                            <th scope="col">Ticket</th>
                            <th scope="col">Handicap</th>
                            <th scope="col">N° CPF</th>
                            <th scope="col">Statut</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of rows">
                            <td>{{row.line}}</td>
                            <td>{{row.firstname}}</td>
                            <td>{{row.lastname}}</td>
                            <td>{{row.email}}</td>
                            <td>{{row.phoneNumber}}</td>
                            <td>{{row.sessionCode}}</td>
                            <td>{{row.voucherCode}}</td>
                            <td>{{row.psh ? 'Oui' : 'Non'}}</td>
                            <td>{{row.fileNumber}}</td>
                            <td [title]="row.messages.join(' ; ')">
                                <span class="badge" [ngClass]="{
                                    'badge-success': row.status === 'valid',
                                    'badge-warning': row.status === 'incomplete',
                                    'badge-danger': row.status === 'error'
                                }">{{statusLabels[row.status]}}</span>
                                <small *ngFor="let message of row.messages" class="d-block text-secondary">
                                    {{message}}
                                </small>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p class="mt-2 mb-2">
                <strong>{{validRows.length}}</strong> ligne(s) valide(s) / <strong>{{rows.length}}</strong> ligne(s)
                au total
                <span *ngIf="countByStatus('incomplete') > 0" class="text-secondary">
                    · {{countByStatus('incomplete')}} incomplète(s)
                </span>
                <span *ngIf="countByStatus('error') > 0" class="text-secondary">
                    · {{countByStatus('error')}} en erreur
                </span>
            </p>
            <div class="form-check">
                <input class="form-check-input" type="checkbox" id="byPassWarningInput" [(ngModel)]="byPassWarning">
                <label class="form-check-label" for="byPassWarningInput">
                    Forcer la création malgré les avertissements (email déjà pré-inscrit ou déjà utilisateur, session
                    complète)
                </label>
            </div>
        </ng-container>
    </ng-container>

    <!-- Étape 3 : import -->
    <ng-container *ngIf="step === 3">
        <ngb-progressbar type="primary" [value]="importProgress" [showValue]="true" class="mb-2"></ngb-progressbar>
        <p class="mb-2">
            {{importedRows.length}} / {{importTotal}} pré-inscription(s) traitée(s)
        </p>
        <div #importLog class="import-log">
            <div *ngFor="let row of importedRows" class="import-log-line">
                <ng-container [ngSwitch]="row.status">
                    <ng-container *ngSwitchCase="'imported'">
                        <i class="fas fa-check text-success"></i>
                        Créée : {{row.firstname}} {{row.lastname}} ({{row.session?.code}})
                    </ng-container>
                    <ng-container *ngSwitchCase="'warning'">
                        <i class="fas fa-exclamation-triangle text-warning"></i>
                        Non importée : {{row.firstname}} {{row.lastname}} ({{row.session?.code}}) –
                        {{row.messages[row.messages.length - 1]}}
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <i class="fas fa-times text-danger"></i>
                        Erreur : {{row.firstname}} {{row.lastname}} ({{row.session?.code}}) –
                        {{row.messages[row.messages.length - 1]}}
                    </ng-container>
                </ng-container>
            </div>
        </div>
        <div *ngIf="importDone" class="alert alert-info mt-3 mb-0">
            Import terminé :
            {{countByStatus('imported')}} importée(s),
            {{countByStatus('warning')}} non importée(s) (avertissement),
            {{countByStatus('server_error')}} en erreur serveur,
            {{countByStatus('incomplete')}} incomplète(s) et {{countByStatus('error')}} en erreur ignorée(s).
        </div>
    </ng-container>
</div>
<div class="modal-footer">
    <ng-container *ngIf="step === 1">
        <button type="button" class="btn btn-outline-danger" (click)="dismiss()">Annuler</button>
        <button type="button" class="btn btn-outline-success" [disabled]="!file" (click)="next()">
            Suivant
        </button>
    </ng-container>

    <ng-container *ngIf="step === 2">
        <button type="button" class="btn btn-outline-primary" (click)="previous()">Précédent</button>
        <button type="button" class="btn btn-outline-success" [disabled]="analyzing || validRows.length === 0"
            (click)="startImport()">
            Importer
        </button>
    </ng-container>

    <ng-container *ngIf="step === 3">
        <button type="button" class="btn btn-outline-primary" [disabled]="!importDone || generatingReport"
            (click)="downloadReport()">
            <span *ngIf="generatingReport" class="button-loader"></span>
            <i class="fas fa-file-excel"></i>
            Rapport
        </button>
        <button type="button" class="btn btn-outline-success" [disabled]="importing" (click)="close()">
            Fermer
        </button>
    </ng-container>
</div>
